/***
 * @module RootActions
 */
import {createAction, props} from '@ngrx/store';

export const waitForFieldsGuardStarted = createAction('[FilledStore 🔑] waiting for fields', props<{name: string, keys: any[]}>());
export const waitForFieldsGuardOk = createAction('[FilledStore 🔑] fields ok', props<{name: string, keys: any[]}>());
export const waitForEntitiesGuardStarted = createAction('[FilledStore 🔑] waiting for entities', props<{name: string, entities: any[]}>());
export const waitForEntitiesGuardOk = createAction('[FilledStore 🔑] entities ok', props<{name: string, entities: any[]}>());

export const getOkActionName = (name: string) => `[WFS 🔑] selector ${name} ok`;
export const getActionName = (name: string) => `[WFS 🔑] wait for ${name}`;
export const waitForSelectorFactory = (name: string) =>
	createAction(getActionName(name), props<{name: string}>());
export const waitForSelectorGuardOk = (name: string) =>
	createAction(getOkActionName(name), props<{name: string}>());

export const navigateEnd = createAction('— navigate end 🚀 —', props<{url: string}>());

